// import { createSelector } from 'reselect';

export const getActiveTheme = state => state.themes.activeTheme;
export const getThemes = state => state.themes.themes;
